export var CompanyAddressType = /*#__PURE__*/function (CompanyAddressType) {
  CompanyAddressType["Postal"] = "Postal";
  CompanyAddressType["Billing"] = "Billing";
  return CompanyAddressType;
}(CompanyAddressType || {});
export const companyAddressTypeLabels = {
  [CompanyAddressType.Billing]: "Rechnungsanschrift",
  [CompanyAddressType.Postal]: "Firmenanschrift"
};